import { useState } from "react";
import { submitForm } from "../api/api.form";

export interface ContactFormData {
    name: string;
    email: string;
    message: string;
    terms: boolean;
}

const initialState: ContactFormData = {
    name: "",
    email: "",
    message: "",
    terms: false,
};

export function useContactForm() {
    const [form, setForm] = useState<ContactFormData>(initialState);
    const [errors, setErrors] = useState<Partial<ContactFormData>>({});
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [serverError, setServerError] = useState(false);

    const validate = () => {
        const newErrors: Partial<ContactFormData> = {};
        if (!form.name.trim()) newErrors.name = "true";
        if (!form.email.trim()) newErrors.email = "true";
        if (form.message.trim().length < 10) newErrors.message = "true";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (field: keyof ContactFormData) => (value: string | boolean) => {
        setForm((prev) => ({ ...prev, [field]: value }));
        setErrors((prev) => ({ ...prev, [field]: undefined }));
    };

    const handleSubmit = async () => {
        if (!validate()) return;
        setLoading(true);
        setServerError(false);
        const result = await submitForm(form as any);
        setLoading(false);
        if (result.success) {
            setSuccess(true);
            setForm(initialState);
        } else {
            setServerError(true);
        }
    };

    return { form, errors, loading, success, serverError, handleChange, handleSubmit };
}
